import React, { Component } from "react";
import { PropTypes } from "prop-types";
import styled from "styled-components";

export default class PostTo extends Component {
  static propTypes = {
    channel: PropTypes.array,
    companyChannelHandler: PropTypes.array
  };
  render() {
    const { channel, companyChannelHandler } = this.props;
    let name = [];
    channel.forEach(item => {
      let temp = companyChannelHandler.find(function(obj) {
        return item.companyChannelHandler == obj.companyChannelHandler;
      });
      if (temp) {
        name.push({
          companyChannelHandlerName: temp.name
        });
      }
    });

    return (
      <Wrapper>
        Post to :{" "}
        {name.map((row, index) => {
          return (
            <Span key={"span" + index}>{row.companyChannelHandlerName},</Span>
          );
        })}{" "}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding-left: 8px;
  padding-top: 8px;
  color: #919191;
  line-height: 1.1em;
`;

const Span = styled.div`
  display: inline-block;
  margin-right: 5px;
`;



// WEBPACK FOOTER //
// ./src/module-schedule/PostTo.js